import { UI_STRINGS } from '@/lib/constants/ui-strings';
import { INVESTOR_FIRM_LOGO_LABEL, INVESTOR_CONTACT_PHOTO_LABEL } from './investor-form.constants';
import { MARKET_MODEL_FIELDS } from './investor-options';

const S = UI_STRINGS.INVESTOR_PROFILE;

type MarketModelField = (typeof MARKET_MODEL_FIELDS)[number]['name'];

/** "Market Model Preferences (B2B)": the section's heading plus the row's own label. */
export function marketModelLabel(field: MarketModelField): string {
  const row = MARKET_MODEL_FIELDS.find((candidate) => candidate.name === field);
  return `${S.MARKET_MODEL_PREFERENCES} (${row?.label ?? field})`;
}

/**
 * Each investor profile field's on-screen label, for the summary at the top of a panel
 * whose Save was refused (FR-189). Keyed by form field and ordered as the panels lay the
 * fields out.
 */
export const INVESTOR_FIELD_LABELS: Readonly<Record<string, string>> = {
  // About
  logoFileKey: INVESTOR_FIRM_LOGO_LABEL,
  profilePhotoFileKey: INVESTOR_CONTACT_PHOTO_LABEL,
  firmName: S.FUND_NAME,
  investorType: S.INVESTOR_TYPE,
  contactName: S.CONTACT_NAME,
  contactTitle: S.CONTACT_TITLE,
  phone: S.PHONE,
  websiteUrl: S.WEBSITE,
  linkedinUrl: S.LINKEDIN,
  intro: S.BIO,
  // Location
  addressStreet: S.ADDRESS_STREET_1,
  addressStreet2: S.ADDRESS_STREET_2,
  addressCity: S.CITY,
  addressPostalCode: S.POSTAL_CODE,
  addressCountry: S.COUNTRY,
  addressState: S.STATE,
  // What we invest in
  prefAmountLow: S.MIN_INVESTMENT,
  prefAmountHigh: S.MAX_INVESTMENT,
  prefMinRevenue: S.MIN_REVENUE,
  prefRecurringRevenue: S.RECURRING_REVENUE,
  preferredStages: S.PREFERRED_STAGES,
  activelyDeploying: S.ACTIVELY_DEPLOYING,
  prefB2b: marketModelLabel('prefB2b'),
  prefB2c: marketModelLabel('prefB2c'),
  prefB2g: marketModelLabel('prefB2g'),
  prefSaas: marketModelLabel('prefSaas'),
  prefAi: marketModelLabel('prefAi'),
  prefLeadOrFollow: S.LEAD_OR_FOLLOW,
  prefOtherCriteria: S.OTHER_CRITERIA,
  industries: S.INDUSTRIES,
  // Founder preferences
  prefFemaleLed: S.FEMALE_LED_STARTUPS,
  prefUnderrepresented: S.UNDERREPRESENTED_FOUNDERS,
  prefUnderrepresentedCategories: S.UNDERREPRESENTED_CATEGORIES,
  interestOfficeHours: S.OFFICE_HOURS_INTEREST,
  interestFounderFunderEvents: S.FOUNDER_FUNDER_EVENTS_INTEREST,
  // Preferred geographies and colleague contacts
  geographies: S.GEOGRAPHIES,
  colleagueContacts: S.COLLEAGUE_CONTACTS,
};
